// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"style_mainContainer__HmfNP","animation":"style_animation__c3pUT","btnHoverStyle":"style_btnHoverStyle__kEN9N"};